module.exports = __webpack_public_path__ + "static/media/Francisco St, San Francisco, CA1.a0c5ad24.jpg";